import { CreateForeignBusinessCustomerRequestDto } from '@/api/generated';
import {
  Address,
  CustomerStatusOptionsTranslation,
  FlagOptionsTranslation,
} from '@/assets/locales/utils/dictionaries/dictionaries.translation.pl.ts';
import { customersIndividualCreateTranslation } from '@/assets/locales/views/customersIndividualCreate/customersIndividualCreate.translation.pl.ts';

export type CustomersForeignCreateTranslation = {
  button: {
    cancel: string;
    save: string;
  };
  form: Form & {
    address: Address;
    flagOption: FlagOptionsTranslation;
    statusOption: CustomerStatusOptionsTranslation;
  };
  titleAdd: string;
  titleEdit: string;
};

type Form = Record<
  keyof Omit<CreateForeignBusinessCustomerRequestDto, 'address' | 'firstContact'>,
  string
>;

export const customersForeignCreateTranslation: CustomersForeignCreateTranslation = {
  ...customersIndividualCreateTranslation,
  titleAdd: 'Dodaj klienta zagranicznego',
  titleEdit: 'Edycja klienta zagranicznego',
};
